//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { lowerCase } from '~/utils/utils'
import BlueDeal from '~/components/section/banners/blueDeal'
import FreeCancellation from '~/components/section/banners/freeCancellation'
import TopFlotilla from '~/components/section/banners/topFlotilla'

export default {
  name: 'OffersHome',
  components: {
    FreeCancellation,
    BlueDeal
  },
  props: {
    slider: {
      type: Object,
      default: () => {}
    }
  }
}
